import { useDispatch, useSelector } from "react-redux";
import { OperationalDashboardActions } from "../../../../store/ducks/operationalDashboard";

export const useTodayAgendaViewModel = () => {
	const dispatch = useDispatch();
	const isRequested = useSelector(
		(state: any) => state?.operationalDashboard?.agendaInterestRequested
	);

	return {
		isRequested,
		handleRequestAgendaAccess: () => {
			if (!isRequested) {
				dispatch(OperationalDashboardActions.agenda_interest_request());
			}
		},
	};
};
